import { connect } from 'react-redux'
import { compose, path, applySpec } from 'ramda'
import { mapProps } from 'recompose'
import modules from 'router/modules'

const mapStateToProps = state => {
  const componentName = path(['router', 'result', 'Component'], state)
  return { Component: modules[componentName] }
}

export default compose(
  connect(mapStateToProps),
  mapProps(({ Component, propsFromRails }) => ({
    ...propsFromRails,
    Component,
  })),
  connect(
    applySpec({
      title: path(['router', 'result', 'title']),
    })
  )
)
